export function createResourceGroup(type) {
    return {
        resourceType: type,
        resources: []
    };
}
